// removed by extract-text-webpack-plugin
module.exports = {"root":"ParagraphImageText-module-root-3zZ67","isImageLeft":"ParagraphImageText-module-isImageLeft-Mo3Cg","column":"ParagraphImageText-module-column-3NUki","caption":"ParagraphImageText-module-caption-2QvRd","img":"ParagraphImageText-module-img-ZahBj","cta-wrap":"ParagraphImageText-module-cta-wrap-41Ldr","ctaWrap":"ParagraphImageText-module-cta-wrap-41Ldr"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/TechnicalDocument/components/ParagraphImageText/ParagraphImageText.module.scss
// module id = 1316
// module chunks = 0